import { render } from "./FormContentBlock.vue?vue&type=template&id=def0df62&scoped=true"
import script from "./FormContentBlock.vue?vue&type=script&lang=js"
export * from "./FormContentBlock.vue?vue&type=script&lang=js"

import "./FormContentBlock.vue?vue&type=style&index=0&id=def0df62&lang=css"
import "./FormContentBlock.vue?vue&type=style&index=1&id=def0df62&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-def0df62"]])

export default __exports__